// @generated by protobuf-ts 2.9.4
// @generated from protobuf file "mlmbox/types/distribution.proto" (package "mlmbox.types", syntax proto3)
// tslint:disable
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Account_Info } from "./account.ts";
import { Bonus_Summary } from "./bonus.ts";
/**
 * @generated from protobuf message mlmbox.types.Distribution
 */
export interface Distribution {
}
/**
 * @generated from protobuf message mlmbox.types.Distribution.State
 */
export interface Distribution_State {
    /**
     * @generated from protobuf field: string web3_address = 1;
     */
    web3Address: string;
    /**
     * @generated from protobuf field: uint32 web3_address_attached_at = 2;
     */
    web3AddressAttachedAt: number;
    /**
     * @generated from protobuf field: mlmbox.types.Distribution.Holder.Balance holder_balance = 3;
     */
    holderBalance?: Distribution_Holder_Balance;
    /**
     * @generated from protobuf field: string income_balance_frozen = 4;
     */
    incomeBalanceFrozen: string;
    /**
     * @generated from protobuf field: mlmbox.types.Bonus.Summary income_bonuses_statistics = 5;
     */
    incomeBonusesStatistics?: Bonus_Summary;
    /**
     * @generated from protobuf field: string points_balance_frozen = 6;
     */
    pointsBalanceFrozen: string;
    /**
     * @generated from protobuf field: string points_balance_available = 7;
     */
    pointsBalanceAvailable: string;
    /**
     * @generated from protobuf field: string cashback_balance_frozen = 8;
     */
    cashbackBalanceFrozen: string;
    /**
     * @generated from protobuf field: mlmbox.types.Bonus.Summary cashback_bonuses_statistics = 9;
     */
    cashbackBonusesStatistics?: Bonus_Summary;
    /**
     * @generated from protobuf field: mlmbox.types.Distribution.State.Config config = 10;
     */
    config?: Distribution_State_Config;
}
/**
 * @generated from protobuf message mlmbox.types.Distribution.State.Config
 */
export interface Distribution_State_Config {
    /**
     * @generated from protobuf field: string personal_purchase_game_token_bonus_percent = 1;
     */
    personalPurchaseGameTokenBonusPercent: string;
    /**
     * @generated from protobuf field: string partners_purchase_game_token_bonus_percent = 2;
     */
    partnersPurchaseGameTokenBonusPercent: string;
    /**
     * @generated from protobuf field: string partners_purchase_points_bonus_percent = 3;
     */
    partnersPurchasePointsBonusPercent: string;
    /**
     * @generated from protobuf field: string partners_purchase_points_bonus_usdt_rate = 4;
     */
    partnersPurchasePointsBonusUsdtRate: string;
}
/**
 * @generated from protobuf message mlmbox.types.Distribution.Holder
 */
export interface Distribution_Holder {
    /**
     * @generated from protobuf field: mlmbox.types.Distribution.Holder.State state = 1;
     */
    state?: Distribution_Holder_State;
    /**
     * @generated from protobuf field: uint32 partners_quantity = 2;
     */
    partnersQuantity: number;
    /**
     * @generated from protobuf field: mlmbox.types.Distribution.Holder.Balance partners_hold_balance = 3;
     */
    partnersHoldBalance?: Distribution_Holder_Balance;
    /**
     * @generated from protobuf field: repeated mlmbox.types.Distribution.Holder.Partner top_partners = 4;
     */
    topPartners: Distribution_Holder_Partner[];
    /**
     * @generated from protobuf field: string partners_turnover = 5;
     */
    partnersTurnover: string; // суммарный товарооборот который начислен от партнеров
}
/**
 * @generated from protobuf message mlmbox.types.Distribution.Holder.Balance
 */
export interface Distribution_Holder_Balance {
    /**
     * @generated from protobuf field: string web3 = 1;
     */
    web3: string;
    /**
     * @generated from protobuf field: string wallet = 2;
     */
    wallet: string;
    /**
     * @generated from protobuf field: string exchange = 3;
     */
    exchange: string;
}
/**
 * @generated from protobuf message mlmbox.types.Distribution.Holder.State
 */
export interface Distribution_Holder_State {
    /**
     * @generated from protobuf field: string web3_address = 1;
     */
    web3Address: string;
    /**
     * @generated from protobuf field: uint32 web3_address_attached_at = 2;
     */
    web3AddressAttachedAt: number;
    /**
     * @generated from protobuf field: mlmbox.types.Distribution.Holder.Balance balance = 3;
     */
    balance?: Distribution_Holder_Balance;
}
/**
 * @generated from protobuf message mlmbox.types.Distribution.Holder.Partner
 */
export interface Distribution_Holder_Partner {
    /**
     * @generated from protobuf field: mlmbox.types.Account.Info account = 1;
     */
    account?: Account_Info;
    /**
     * @generated from protobuf field: mlmbox.types.Distribution.Holder.State state = 2;
     */
    state?: Distribution_Holder_State;
    /**
     * @generated from protobuf field: string turnover_for_sponsor = 3;
     */
    turnoverForSponsor: string; // товарооборот который начислен спонсору от пользователя
}
// @generated message type with reflection information, may provide speed optimized methods
class Distribution$Type extends MessageType<Distribution> {
    constructor() {
        super("mlmbox.types.Distribution", []);
    }
    create(value?: PartialMessage<Distribution>): Distribution {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<Distribution>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Distribution): Distribution {
        return target ?? this.create();
    }
    internalBinaryWrite(message: Distribution, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Distribution
 */
export const Distribution = new Distribution$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Distribution_State$Type extends MessageType<Distribution_State> {
    constructor() {
        super("mlmbox.types.Distribution.State", [
            { no: 1, name: "web3_address", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "web3_address_attached_at", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "holder_balance", kind: "message", T: () => Distribution_Holder_Balance },
            { no: 4, name: "income_balance_frozen", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "income_bonuses_statistics", kind: "message", T: () => Bonus_Summary },
            { no: 6, name: "points_balance_frozen", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "points_balance_available", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "cashback_balance_frozen", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "cashback_bonuses_statistics", kind: "message", T: () => Bonus_Summary },
            { no: 10, name: "config", kind: "message", T: () => Distribution_State_Config }
        ]);
    }
    create(value?: PartialMessage<Distribution_State>): Distribution_State {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.web3Address = "";
        message.web3AddressAttachedAt = 0;
        message.incomeBalanceFrozen = "";
        message.pointsBalanceFrozen = "";
        message.pointsBalanceAvailable = "";
        message.cashbackBalanceFrozen = "";
        if (value !== undefined)
            reflectionMergePartial<Distribution_State>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Distribution_State): Distribution_State {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string web3_address */ 1:
                    message.web3Address = reader.string();
                    break;
                case /* uint32 web3_address_attached_at */ 2:
                    message.web3AddressAttachedAt = reader.uint32();
                    break;
                case /* mlmbox.types.Distribution.Holder.Balance holder_balance */ 3:
                    message.holderBalance = Distribution_Holder_Balance.internalBinaryRead(reader, reader.uint32(), options, message.holderBalance);
                    break;
                case /* string income_balance_frozen */ 4:
                    message.incomeBalanceFrozen = reader.string();
                    break;
                case /* mlmbox.types.Bonus.Summary income_bonuses_statistics */ 5:
                    message.incomeBonusesStatistics = Bonus_Summary.internalBinaryRead(reader, reader.uint32(), options, message.incomeBonusesStatistics);
                    break;
                case /* string points_balance_frozen */ 6:
                    message.pointsBalanceFrozen = reader.string();
                    break;
                case /* string points_balance_available */ 7:
                    message.pointsBalanceAvailable = reader.string();
                    break;
                case /* string cashback_balance_frozen */ 8:
                    message.cashbackBalanceFrozen = reader.string();
                    break;
                case /* mlmbox.types.Bonus.Summary cashback_bonuses_statistics */ 9:
                    message.cashbackBonusesStatistics = Bonus_Summary.internalBinaryRead(reader, reader.uint32(), options, message.cashbackBonusesStatistics);
                    break;
                case /* mlmbox.types.Distribution.State.Config config */ 10:
                    message.config = Distribution_State_Config.internalBinaryRead(reader, reader.uint32(), options, message.config);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Distribution_State, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string web3_address = 1; */
        if (message.web3Address !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.web3Address);
        /* uint32 web3_address_attached_at = 2; */
        if (message.web3AddressAttachedAt !== 0)
            writer.tag(2, WireType.Varint).uint32(message.web3AddressAttachedAt);
        /* mlmbox.types.Distribution.Holder.Balance holder_balance = 3; */
        if (message.holderBalance)
            Distribution_Holder_Balance.internalBinaryWrite(message.holderBalance, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string income_balance_frozen = 4; */
        if (message.incomeBalanceFrozen !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.incomeBalanceFrozen);
        /* mlmbox.types.Bonus.Summary income_bonuses_statistics = 5; */
        if (message.incomeBonusesStatistics)
            Bonus_Summary.internalBinaryWrite(message.incomeBonusesStatistics, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* string points_balance_frozen = 6; */
        if (message.pointsBalanceFrozen !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.pointsBalanceFrozen);
        /* string points_balance_available = 7; */
        if (message.pointsBalanceAvailable !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.pointsBalanceAvailable);
        /* string cashback_balance_frozen = 8; */
        if (message.cashbackBalanceFrozen !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.cashbackBalanceFrozen);
        /* mlmbox.types.Bonus.Summary cashback_bonuses_statistics = 9; */
        if (message.cashbackBonusesStatistics)
            Bonus_Summary.internalBinaryWrite(message.cashbackBonusesStatistics, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* mlmbox.types.Distribution.State.Config config = 10; */
        if (message.config)
            Distribution_State_Config.internalBinaryWrite(message.config, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Distribution.State
 */
export const Distribution_State = new Distribution_State$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Distribution_State_Config$Type extends MessageType<Distribution_State_Config> {
    constructor() {
        super("mlmbox.types.Distribution.State.Config", [
            { no: 1, name: "personal_purchase_game_token_bonus_percent", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "partners_purchase_game_token_bonus_percent", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "partners_purchase_points_bonus_percent", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "partners_purchase_points_bonus_usdt_rate", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Distribution_State_Config>): Distribution_State_Config {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.personalPurchaseGameTokenBonusPercent = "";
        message.partnersPurchaseGameTokenBonusPercent = "";
        message.partnersPurchasePointsBonusPercent = "";
        message.partnersPurchasePointsBonusUsdtRate = "";
        if (value !== undefined)
            reflectionMergePartial<Distribution_State_Config>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Distribution_State_Config): Distribution_State_Config {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string personal_purchase_game_token_bonus_percent */ 1:
                    message.personalPurchaseGameTokenBonusPercent = reader.string();
                    break;
                case /* string partners_purchase_game_token_bonus_percent */ 2:
                    message.partnersPurchaseGameTokenBonusPercent = reader.string();
                    break;
                case /* string partners_purchase_points_bonus_percent */ 3:
                    message.partnersPurchasePointsBonusPercent = reader.string();
                    break;
                case /* string partners_purchase_points_bonus_usdt_rate */ 4:
                    message.partnersPurchasePointsBonusUsdtRate = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Distribution_State_Config, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string personal_purchase_game_token_bonus_percent = 1; */
        if (message.personalPurchaseGameTokenBonusPercent !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.personalPurchaseGameTokenBonusPercent);
        /* string partners_purchase_game_token_bonus_percent = 2; */
        if (message.partnersPurchaseGameTokenBonusPercent !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.partnersPurchaseGameTokenBonusPercent);
        /* string partners_purchase_points_bonus_percent = 3; */
        if (message.partnersPurchasePointsBonusPercent !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.partnersPurchasePointsBonusPercent);
        /* string partners_purchase_points_bonus_usdt_rate = 4; */
        if (message.partnersPurchasePointsBonusUsdtRate !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.partnersPurchasePointsBonusUsdtRate);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Distribution.State.Config
 */
export const Distribution_State_Config = new Distribution_State_Config$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Distribution_Holder$Type extends MessageType<Distribution_Holder> {
    constructor() {
        super("mlmbox.types.Distribution.Holder", [
            { no: 1, name: "state", kind: "message", T: () => Distribution_Holder_State },
            { no: 2, name: "partners_quantity", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "partners_hold_balance", kind: "message", T: () => Distribution_Holder_Balance },
            { no: 4, name: "top_partners", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Distribution_Holder_Partner },
            { no: 5, name: "partners_turnover", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Distribution_Holder>): Distribution_Holder {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.partnersQuantity = 0;
        message.topPartners = [];
        message.partnersTurnover = "";
        if (value !== undefined)
            reflectionMergePartial<Distribution_Holder>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Distribution_Holder): Distribution_Holder {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* mlmbox.types.Distribution.Holder.State state */ 1:
                    message.state = Distribution_Holder_State.internalBinaryRead(reader, reader.uint32(), options, message.state);
                    break;
                case /* uint32 partners_quantity */ 2:
                    message.partnersQuantity = reader.uint32();
                    break;
                case /* mlmbox.types.Distribution.Holder.Balance partners_hold_balance */ 3:
                    message.partnersHoldBalance = Distribution_Holder_Balance.internalBinaryRead(reader, reader.uint32(), options, message.partnersHoldBalance);
                    break;
                case /* repeated mlmbox.types.Distribution.Holder.Partner top_partners */ 4:
                    message.topPartners.push(Distribution_Holder_Partner.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string partners_turnover */ 5:
                    message.partnersTurnover = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Distribution_Holder, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* mlmbox.types.Distribution.Holder.State state = 1; */
        if (message.state)
            Distribution_Holder_State.internalBinaryWrite(message.state, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* uint32 partners_quantity = 2; */
        if (message.partnersQuantity !== 0)
            writer.tag(2, WireType.Varint).uint32(message.partnersQuantity);
        /* mlmbox.types.Distribution.Holder.Balance partners_hold_balance = 3; */
        if (message.partnersHoldBalance)
            Distribution_Holder_Balance.internalBinaryWrite(message.partnersHoldBalance, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated mlmbox.types.Distribution.Holder.Partner top_partners = 4; */
        for (let i = 0; i < message.topPartners.length; i++)
            Distribution_Holder_Partner.internalBinaryWrite(message.topPartners[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string partners_turnover = 5; */
        if (message.partnersTurnover !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.partnersTurnover);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Distribution.Holder
 */
export const Distribution_Holder = new Distribution_Holder$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Distribution_Holder_Balance$Type extends MessageType<Distribution_Holder_Balance> {
    constructor() {
        super("mlmbox.types.Distribution.Holder.Balance", [
            { no: 1, name: "web3", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "wallet", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "exchange", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Distribution_Holder_Balance>): Distribution_Holder_Balance {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.web3 = "";
        message.wallet = "";
        message.exchange = "";
        if (value !== undefined)
            reflectionMergePartial<Distribution_Holder_Balance>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Distribution_Holder_Balance): Distribution_Holder_Balance {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string web3 */ 1:
                    message.web3 = reader.string();
                    break;
                case /* string wallet */ 2:
                    message.wallet = reader.string();
                    break;
                case /* string exchange */ 3:
                    message.exchange = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Distribution_Holder_Balance, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string web3 = 1; */
        if (message.web3 !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.web3);
        /* string wallet = 2; */
        if (message.wallet !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.wallet);
        /* string exchange = 3; */
        if (message.exchange !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.exchange);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Distribution.Holder.Balance
 */
export const Distribution_Holder_Balance = new Distribution_Holder_Balance$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Distribution_Holder_State$Type extends MessageType<Distribution_Holder_State> {
    constructor() {
        super("mlmbox.types.Distribution.Holder.State", [
            { no: 1, name: "web3_address", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "web3_address_attached_at", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "balance", kind: "message", T: () => Distribution_Holder_Balance }
        ]);
    }
    create(value?: PartialMessage<Distribution_Holder_State>): Distribution_Holder_State {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.web3Address = "";
        message.web3AddressAttachedAt = 0;
        if (value !== undefined)
            reflectionMergePartial<Distribution_Holder_State>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Distribution_Holder_State): Distribution_Holder_State {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string web3_address */ 1:
                    message.web3Address = reader.string();
                    break;
                case /* uint32 web3_address_attached_at */ 2:
                    message.web3AddressAttachedAt = reader.uint32();
                    break;
                case /* mlmbox.types.Distribution.Holder.Balance balance */ 3:
                    message.balance = Distribution_Holder_Balance.internalBinaryRead(reader, reader.uint32(), options, message.balance);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Distribution_Holder_State, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string web3_address = 1; */
        if (message.web3Address !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.web3Address);
        /* uint32 web3_address_attached_at = 2; */
        if (message.web3AddressAttachedAt !== 0)
            writer.tag(2, WireType.Varint).uint32(message.web3AddressAttachedAt);
        /* mlmbox.types.Distribution.Holder.Balance balance = 3; */
        if (message.balance)
            Distribution_Holder_Balance.internalBinaryWrite(message.balance, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Distribution.Holder.State
 */
export const Distribution_Holder_State = new Distribution_Holder_State$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Distribution_Holder_Partner$Type extends MessageType<Distribution_Holder_Partner> {
    constructor() {
        super("mlmbox.types.Distribution.Holder.Partner", [
            { no: 1, name: "account", kind: "message", T: () => Account_Info },
            { no: 2, name: "state", kind: "message", T: () => Distribution_Holder_State },
            { no: 3, name: "turnover_for_sponsor", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Distribution_Holder_Partner>): Distribution_Holder_Partner {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.turnoverForSponsor = "";
        if (value !== undefined)
            reflectionMergePartial<Distribution_Holder_Partner>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Distribution_Holder_Partner): Distribution_Holder_Partner {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* mlmbox.types.Account.Info account */ 1:
                    message.account = Account_Info.internalBinaryRead(reader, reader.uint32(), options, message.account);
                    break;
                case /* mlmbox.types.Distribution.Holder.State state */ 2:
                    message.state = Distribution_Holder_State.internalBinaryRead(reader, reader.uint32(), options, message.state);
                    break;
                case /* string turnover_for_sponsor */ 3:
                    message.turnoverForSponsor = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Distribution_Holder_Partner, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* mlmbox.types.Account.Info account = 1; */
        if (message.account)
            Account_Info.internalBinaryWrite(message.account, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* mlmbox.types.Distribution.Holder.State state = 2; */
        if (message.state)
            Distribution_Holder_State.internalBinaryWrite(message.state, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string turnover_for_sponsor = 3; */
        if (message.turnoverForSponsor !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.turnoverForSponsor);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Distribution.Holder.Partner
 */
export const Distribution_Holder_Partner = new Distribution_Holder_Partner$Type();
